import { useMemo } from 'react'

import { formatMinutes, formatBytes } from '../helpers/tariff.helpers'

import { Price } from '~/basket/model/common/price.model'

interface useTariffCardProps {
  data: number
  minutes: number
  prices?: Price[]
}

export default function useTariffCard({ data, minutes, prices }: useTariffCardProps) {
  const mainPrice = prices ? prices.shift() : undefined

  const formattedMinutes = useMemo(() => formatMinutes(minutes), [minutes])

  const formattedBytes = useMemo(() => formatBytes(data), [data])

  return {
    formattedMinutes,
    formattedBytes,
    mainPrice,
  }
}
